import styled from "@emotion/styled";

export const OrganizationWrapper = styled.div`
	display: flex;
	position: relative;
	min-height: 100vh;
`;
